module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M2 32h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v7a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4h24v24H4v-5a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v7c0 1.106.894 2 2 2zm19-18H10v-3.39c0-.594-.53-.788-1-.43l-6.644 5.174c-.47.356-.478.936-.008 1.292L9 21.82c.472.358 1 .164 1-.43V18h11c.55 0 1-.448 1-1v-2c0-.552-.45-1-1-1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/move-right-1.js
// module id = 1290
// module chunks = 14